
define(
	'CSeComm.HeaderProfileExtension.HeaderProfileExtension'
,   [
		'SuiteDynamics.HeaderProfileExtension.CartChanges',
		'Profile.Model',
		'SC.Configuration',
		'Header.Profile.View',
		'underscore',
		'Handlebars'
	]
,   function (
		CartChanges,
		ProfileModel,
		Configuration,
		HeaderProfileView,
		_,
		Handlebars
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			registerHandlebarsNavMenuHelper();

			CartChanges.mountToApp(container);

			_.extend(HeaderProfileView.prototype, {
				getContext: function() {
					var profile = ProfileModel.getInstance()
					,	is_loading = !_.getPathFromObject(Configuration, 'performance.waitForUserProfile', true) && ProfileModel.getPromise().state() !== 'resolved'
					,	is_logged_in = profile.get('isLoggedIn') === 'T' && profile.get('isGuest') === 'F';

					// @class Header.Profile.View.Context
					return {
						// @property {Boolean} showExtendedMenu
						showExtendedMenu: !is_loading && is_logged_in
						// @property {Boolean} showLoginMenu
					,	showLoginMenu: !is_loading && !is_logged_in
						// @property {Boolean} showLoadingMenu
					,	showLoadingMenu: is_loading
						// @property {Boolean} showMyAccountMenu
					,	showMyAccountMenu: !!this.options.showMyAccountMenu
						// @property {String} displayName
					,	displayName: profile.get('firstname') || profile.get('companyname')
						// @property {Boolean} showLogin
					,	showLogin: Configuration.getRegistrationType() !== 'disabled'
						// @property {Boolean} showRegister
					,	showRegister: Configuration.getRegistrationType() === 'optional' || Configuration.getRegistrationType() === 'required'
					};
				}
			});

		}
	};

	function registerHandlebarsNavMenuHelper() {
		Handlebars.registerHelper('eachInChunks', function(array, chunkSize, options) {
			if (!array || !array.length) return options.inverse(this);

			let output = '';
			for (var i = 0; i < array.length; i += chunkSize) {
				let items = array.slice(i, i + chunkSize);
				output += options.fn(items);
			}
			return output;
		});
	}
});
